import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './ui/Button';
import { useIdleLogout } from '../hooks/useIdleLogout';
import { useAuth } from '../context/AuthContext';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const IDLE_WARNING_MS = 29 * 60 * 1000;

const IdleWarningModal = () => {
  const { t } = useTranslation('common');
  const { logout } = useAuth();
  const { showWarning, secondsLeft, extendSession } = useIdleLogout(
    IDLE_TIMEOUT_MS,
    IDLE_WARNING_MS,
    logout,
  );

  if (!showWarning) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 max-w-sm w-full mx-4 space-y-4 text-center">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white">
          {t('idle.title')}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          {t('idle.message', { seconds: secondsLeft })}
        </p>
        <div className="text-3xl font-mono font-bold text-blue-600">
          {secondsLeft}s
        </div>
        <div className="flex gap-3 justify-center">
          <Button
            onClick={extendSession}
            className="px-6 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
          >
            {t('idle.stayLoggedIn')}
          </Button>
          <Button
            onClick={logout}
            variant="secondary"
            className="px-6 py-2 rounded-md text-sm font-medium"
          >
            {t('idle.logout')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;
